<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 10:22:07
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-06 10:05:44
 -->
<template>
  <div class="sysHeader">
    <div class="headerContent">
      <div class="title">
        <img class="logo" src="/static/img/layout/logo.png" alt="">
        <span class="systemName">东方世纪系统运行大数据平台</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sysHeader',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .sysHeader {
    width: 100%;
    height: 100%;
    position: relative;
    .headerContent {
      position: relative;
      width: 100%;
      height: 100%;
      background: url('/static/img/layout/headerBg.png');
      background-size: 100% 100%;
      text-align: center;
      line-height: 70px;
      .title {
        .logo {
          height: 36px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .systemName {
          vertical-align: middle;
          font-size: 28px;
          font-weight: bold;
          background-image: -webkit-linear-gradient(top, rgb(229, 237, 237), rgb(171, 203, 202));
          background-clip: text;
          -webkit-text-fill-color: transparent;
          padding-right: 10px;
          font-family: 'YouSheBiaoTiHei';
        }
      }
  }
}
</style>
